import { render, staticRenderFns } from "./form_validation_email_components.vue?vue&type=template&id=5604843f&scoped=true"
import script from "./form_validation_email_components.vue?vue&type=script&lang=js"
export * from "./form_validation_email_components.vue?vue&type=script&lang=js"
import style0 from "./form_validation_email_components.vue?vue&type=style&index=0&id=5604843f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5604843f",
  null
  
)

export default component.exports